/**
 * Step 0: Identificação e Perfil do Cliente
 */
import type { StepProps } from "./types.js";
import { Input, Select } from "./FormElements.jsx";

export function Step0Identificacao({ form, onChange, T }: StepProps) {
  const set = (key: string, value: unknown) => onChange(key, value);

  return (
    <>
      <h3 style={{ fontSize: 15, fontWeight: 700, color: T.text, margin: "0 0 16px" }}>
        1. Identificação e Perfil do Cliente
      </h3>
      <Input
        label="Nome Completo / Razão Social"
        value={form.nomeCompleto}
        onChange={(e) => set("nomeCompleto", e.target.value)}
        T={T}
      />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <Input
          label="CPF / CNPJ"
          value={form.cpf}
          onChange={(e) => set("cpf", e.target.value)}
          T={T}
        />
        <Input
          label="Data de Nascimento"
          value={form.dataNascimento}
          onChange={(e) => set("dataNascimento", e.target.value)}
          type="date"
          T={T}
        />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <Select
          label="Estado Civil"
          value={form.estadoCivil}
          onChange={(e) => set("estadoCivil", e.target.value)}
          options={[
            ["Solteiro", "Solteiro"],
            ["Casado", "Casado"],
            ["Divorciado", "Divorciado"],
            ["Viúvo", "Viúvo"],
            ["União Estável", "União Estável"],
          ]}
          T={T}
        />
        <Select
          label="Regime de Bens"
          value={form.regimeBens}
          onChange={(e) => set("regimeBens", e.target.value)}
          options={[
            ["", "Selecione..."],
            ["Comunhão Parcial de Bens", "Comunhão Parcial de Bens"],
            ["Comunhão Universal de Bens", "Comunhão Universal de Bens"],
            ["Separação Total de Bens", "Separação Total de Bens"],
            ["Participação Final nos Aquestos", "Participação Final nos Aquestos"],
          ]}
          T={T}
        />
      </div>
      {["Casado", "União Estável"].includes(form.estadoCivil || "") && (
        <label
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            marginBottom: 14,
            cursor: "pointer",
            padding: "9px 12px",
            background: T.bg,
            borderRadius: 8,
            border: `1px solid ${T.border}`,
          }}
        >
          <input
            type="checkbox"
            checked={!!form.pactoAntenupcial}
            onChange={(e) => set("pactoAntenupcial", e.target.checked)}
          />
          <span style={{ fontSize: 12, color: T.text }}>Pacto antenupcial foi lavrado?</span>
        </label>
      )}
      <Input
        label="Profissão / Atividade Principal"
        value={form.profissao}
        onChange={(e) => set("profissao", e.target.value)}
        T={T}
      />
    </>
  );
}
